import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { ContactGroupModels } from '@share-models';

@Injectable({
  providedIn: 'root',
})
export class ContactGroupsService {
  private readonly http = inject(HttpClient);

  public getContactGroups(): Observable<ContactGroupModels.ContactGroupDocument[]> {
    return this.http.get<ContactGroupModels.ContactGroupDocument[]>(api.contactGroups.all);
  }

  public getMembers(
    groupId: string,
  ): Observable<ContactGroupModels.ContactGroupMembersResponse> {
    return this.http.get<ContactGroupModels.ContactGroupMembersResponse>(
      api.contactGroups.members(groupId),
    );
  }

  public create(
    dto: ContactGroupModels.ContactGroupCreateDto,
  ): Observable<ContactGroupModels.ContactGroupDocument> {
    return this.http.post<ContactGroupModels.ContactGroupDocument>(api.contactGroups.create, {
      name: dto.name,
      note: dto.note,
      contactIds: dto.contactIds ?? [],
      orgUserIds: dto.orgUserIds ?? [],
    });
  }

  public update(
    id: string,
    dto: ContactGroupModels.ContactGroupUpdateDto,
  ): Observable<ContactGroupModels.ContactGroupDocument> {
    return this.http.put<ContactGroupModels.ContactGroupDocument>(api.contactGroups.update(id), {
      name: dto.name,
      note: dto.note,
    });
  }

  public updateMembers(
    id: string,
    contactIds: string[],
    orgUserIds: string[],
  ): Observable<ContactGroupModels.ContactGroupDocument> {
    return this.http.put<ContactGroupModels.ContactGroupDocument>(api.contactGroups.members(id), {
      contactIds,
      orgUserIds,
    });
  }

  public removeMember(
    groupId: string,
    memberId: string,
    type: 'contact' | 'orgUser',
  ): Observable<ContactGroupModels.ContactGroupDocument> {
    const body = type === 'contact' ? { contactId: memberId } : { orgUserId: memberId };
    return this.http.post<ContactGroupModels.ContactGroupDocument>(
      api.contactGroups.removeMember(groupId),
      body,
    );
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(api.contactGroups.delete(id));
  }
}
